'use client';
import React from 'react';
import ConfigProvider from '../providers/ConfigProvider';
import Providers from '../providers/Providers';
import AppWrapper from './AppWrapper';
import ErrorBoundary from './ErrorBoundary';
import ChatbotRegistryInitializer from './ChatbotRegistryInitializer';
import { SafeConfigValue } from '@chewy/central-config-cron';

interface ClientProvidersWrapperProps {
  children: React.ReactNode;
  configVars: any;
  athenaConfigs: Map<string, SafeConfigValue> | null;
}

export default function ClientProvidersWrapper({ children, configVars, athenaConfigs }: ClientProvidersWrapperProps) {
  console.log('configVars in ClientProvidersWrapper:', configVars);
  return (
    <Providers configVars={configVars}>
      <ErrorBoundary>
        <ChatbotRegistryInitializer />
        <AppWrapper>
          <ConfigProvider configs={athenaConfigs}>{children}</ConfigProvider>
        </AppWrapper>
      </ErrorBoundary>
    </Providers>
  );
}

